import { Component, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { CategoryModel } from '../../models/categories/category.model';
import { AddOrEditCategoryComponent } from './add-or-edit-category/add-or-edit-category.component';
import { DeleteCategoryComponent } from './delete-category/delete-category.component';
import { TranslateService } from "@ngx-translate/core";
import { Subject, takeUntil } from "rxjs";
import { MenuService } from "../../services/menus/menu.service";
import { AuthenticationService } from "../../../share-modul/services/authentication/authentication.service";

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public listAllCategories: Array<CategoryModel> = new Array<CategoryModel>();
  public imagePath: string = './assets/images/logo/category.png'
  public spinner: boolean = false;
  public items: { [name: string]: MenuItem[] } = {};
  public companyId: string;

  //#endregion
  //#region Constructor
  constructor(
    public dialogService: DialogService,
    private messageService: MessageService,
    private menuService: MenuService,
    public translate: TranslateService,
    private authService: AuthenticationService
  ) {
    this.translate.stream('HEADER.APP_LANGUAGE').subscribe(() => {
      this.addFunctionToAllCategories();
    });
  }

  ngOnInit(): void {
    this.companyId = this.authService.getCompanyId();
    this.loadCategoriesForCompany();
  }
  //#endregion

  //#region Public Methods
  addCategory() {
    const ref = this.dialogService.open(AddOrEditCategoryComponent, {
      data: {
        companyId: this.companyId
      },
      header: this.translate.instant('CATEGORY.ADD_CATEGORY'),
      styleClass: 'dialog_category , ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.loadCategoriesForCompany();
        this.messageService.add({severity:'success', summary: this.translate.instant("CATEGORY.CATEGORY_ADDED"), life: 3000});
      }
    });
  }

  editCategory(category: CategoryModel) {
    const ref = this.dialogService.open(AddOrEditCategoryComponent, {
      data: {
        category: category,
        companyId: this.companyId
      },
      header: this.translate.instant('CATEGORY.EDIT_CATEGORY'),

      styleClass: 'dialog_category , ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.loadCategoriesForCompany();
        this.messageService.add({severity:'success', summary: this.translate.instant("CATEGORY.CATEGORY_EDITED"), life: 3000});
      }
    });
  }

  deleteCategory(id: string) {
    const ref = this.dialogService.open(DeleteCategoryComponent, {
      data: {
        id: id
      },
      header: this.translate.instant('CATEGORY.DELETE_CATEGORY'),
      styleClass: 'dialog_long ,ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.loadCategoriesForCompany();
        this.messageService.add({severity:'success', summary: this.translate.instant("CATEGORY.CATEGORY_DELETED"), life: 3000});
      }
    });
  }

  loadCategoriesForCompany() {
    this.listAllCategories = new Array<CategoryModel>();
    this.spinner = true;
    this.menuService.listCategoryForCompany(this.companyId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.listAllCategories = response;
          this.addFunctionToAllCategories();
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  }

  addFunctionToAllCategories() {
    this.listAllCategories.forEach(category => {
      this.items[category.id] = [{
        label: this.translate.instant('EDIT'),
        command: () => {
          this.editCategory(category);
        }
      },
        {
          label: this.translate.instant('DELETE'),
          command: () => {
            this.deleteCategory(category.id);
          }
        }];
    });
  }

  determineImageUrl(pictureUrl: string) {
    const image = pictureUrl ? pictureUrl : this.imagePath;
    return encodeURI(image);
  }
  //#endregion
}
